<template :class="menuAtivo == 1 ? 'esconde' : ''">
    <aside>
        <div class="titulo margem efeito">
            <div class="m-icone">
                <a href="#" class="icone-menu" title="Menu"
                    onclick="document.getElementById('main').classList.toggle('esconde');return false"></a>
            </div>
        </div>

        <div class="separador margem">
            <div class="m-icone">
                <router-link v-for="(menu, index) of menuData" v-bind:key="menu.icone" :to="getFirstRoute(index)"
                    :class="[menu.icone, isActive(index)]" @click="setActiveMenu(index)"></router-link>
            </div>
        </div>

        <nav class="nav-maior separador" v-if="permissionLoaded">
            <div v-for="subMenu of menuData[activeMenuIndex].subMenus" v-bind:key="subMenu.label">
                <router-link v-if="subMenu.funcionalidade != null ? temPermissao(subMenu.funcionalidade) : true"
                    :to="subMenu.route" active-class="ativo">
                    {{ subMenu.label }}
                </router-link>
            </div>
        </nav>
    </aside>
</template>

<script>
/* eslint-disable */
import { usePermissions } from "@/store/permissionsStore";

export default {
    components: {},
    data() {
        return {
            activeMenuIndex: 0,
            subMenus: [],
        };
    },
    setup() {
        const { permissions, loadPermissions, temPermissao } = usePermissions();
        return {
            permissions,
            loadPermissions,
            temPermissao,
        };
    },
    methods: {
        setActiveMenu(index) {
            this.activeMenuIndex = index;
        },

        isActive(index) {
            if (this.activeMenuIndex == index) {
                return "ativo";
            } else {
                return "";
            }
        },

        getFirstRoute(index) {
            var firstMenu = this.menuData[index].subMenus.find((ele) => {
                if (ele.funcionalidade == null) {
                    return true;
                } else {
                    return this.temPermissao(ele.funcionalidade);
                }
            });
            return firstMenu ? firstMenu.route : "/";
        },
    },

    props: {
        menuData: {
            type: Object,
            default: {},
            required: true,
        },
    },

    computed: {
        permissionLoaded() {
            return this.permissions.permissionLoaded;
        },
    },

    async created() {
        await this.loadPermissions();
    },
};
</script>
